var _circle, _g, _g2, _g3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28.0001,
    r: 19.9982,
    transform: "rotate(-53.0944 28 28.0001)",
    fill: "url(#paint0_radial_714_6789)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_714_6789)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 15.2187,
    transform: "rotate(120 28 28)",
    fill: "url(#paint1_radial_714_6789)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_714_6789)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.9963,
    cy: 27.9961,
    r: 14.4998,
    transform: "rotate(-180 27.9963 27.9961)",
    fill: "url(#paint2_radial_714_6789)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_714_6789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0127 20.7064C27.3731 19.8531 28.5822 19.8531 28.9427 20.7064L30.6501 24.7481C30.7562 24.9993 30.9562 25.1993 31.2074 25.3054L35.2491 27.0128C36.1024 27.3733 36.1024 28.5824 35.2491 28.9428L31.2074 30.6502C30.9562 30.7564 30.7562 30.9563 30.6501 31.2076L28.9427 35.2493C28.5822 36.1025 27.3731 36.1025 27.0127 35.2493L25.3053 31.2076C25.1991 30.9563 24.9992 30.7564 24.7479 30.6502L20.7062 28.9428C19.853 28.5824 19.853 27.3733 20.7062 27.0128L24.7479 25.3054C24.9992 25.1993 25.1991 24.9993 25.3053 24.7481L27.0127 20.7064Z",
    fill: "url(#paint3_linear_714_6789)",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4961 21.1203C33.5635 20.9379 33.8215 20.9379 33.889 21.1203L34.0582 21.5775C34.0794 21.6348 34.1247 21.68 34.182 21.7013L34.6392 21.8705C34.8216 21.938 34.8216 22.1959 34.6392 22.2634L34.182 22.4326C34.1247 22.4539 34.0794 22.4991 34.0582 22.5564L33.889 23.0136C33.8215 23.196 33.5635 23.196 33.4961 23.0136L33.3269 22.5564C33.3056 22.4991 33.2604 22.4539 33.2031 22.4326L32.7459 22.2634C32.5635 22.1959 32.5635 21.938 32.7459 21.8705L33.2031 21.7013C33.2604 21.68 33.3056 21.6348 33.3269 21.5775L33.4961 21.1203Z",
    fill: "url(#paint4_linear_714_6789)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_714_6789",
    x: 12.7793,
    y: 12.7788,
    width: 30.4414,
    height: 30.4424,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.83806
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_714_6789"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_714_6789",
    x: 13.4961,
    y: 13.4964,
    width: 29,
    height: 28.9995,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.83806
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_714_6789"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_714_6789",
    x: 17.238,
    y: 17.657,
    width: 21.4792,
    height: 21.4797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.41903
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.41423
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.420347 0 0 0 0 0.271927 0 0 0 0 0.945833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_714_6789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_714_6789",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_714_6789",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.6762 9.96181) rotate(101.579) scale(37.8254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_714_6789",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5585 14.2729) rotate(101.579) scale(28.7852)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_714_6789",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.3868 14.9174) rotate(101.579) scale(27.4254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_714_6789",
    x1: 27.9777,
    y1: 18.422,
    x2: 27.9777,
    y2: 37.5336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_714_6789",
    x1: 33.6925,
    y1: 20.5892,
    x2: 33.6925,
    y2: 23.5447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B29DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ae927189298057626211cd2a337dd90c.svg";
export { ForwardRef as ReactComponent };